import Stepper from "../components/Stepper";

const OnboardingPage = () => {
  return <Stepper />;

  // currentUser ? (
  //    (
  //     <Stepper />
  //   ) : (
  //     <div
  //       style={{
  //         display: "flex",
  //         alignContent: "center",
  //         justifyContent: "center",
  //         flexDirection: "column",
  //         textAlign: "center",
  //         gap: "20px",
  //       }}
  //     >
  //       <p>{currentUser.email} is NOT AUTHORIZED</p>

  //       <p>
  //         You are not authorized to use this app. Please contact the
  //         administrator (647) 740-4552.
  //       </p>
  //       <button
  //         style={{ width: "200px", alignSelf: "center" }}
  //         onClick={signOutCallToAction}
  //       >
  //         Logout
  //       </button>
  //     </div>
  //   )
  // ) : (
  //   <Login />
  // );
};

export default OnboardingPage;
